<template>
  <div>
    <div class="footer">
      <div>
        <span class="zh">联系我们</span>
        <span class="en">CONTACT US</span>
      </div>
      <div>
        <span>山东琮联电子科技有限公司</span>
        <span>山东省德州市天衢新区袁桥镇崇德八大道2091号连接器项目综合楼2楼211室</span>
        <span>联系人：门总</span>
        <span>邮箱：miao@buyelec.net</span>
      </div>

    </div>
    <div class="bottom">
      <a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备2026053621号-1</a>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.footer {
  height: 163px;
  padding: 0 130px;
  box-sizing: border-box;
  background: #2C445C;
  > div:nth-child(1) {
    transform: scale(0.9);
    font-family: PingFangSC-Semibold, PingFang SC;
    color: #ffffff;
    margin-top: 43px;
    padding-top: 43px;
    .zh {
      font-size: 26px;
      font-weight: 600;
      margin-right: 30px !important;
    }
    .en {
      font-size: 20px;
    }
  }
  > div:nth-child(2) {
    transform: scale(0.9);
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
    > span {
      font-size: 15px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
    }
  }
}
.bottom {
  background-color: #1D3348;
  color: white;
  height: 57px;
  a {
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    font-weight: 600;
    font-size: 14px;
    line-height: 100%;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
